// dateDuration filter
//
//    {{ startTime | dateDuration : endTime : showSeconds : defaultIfEndNull }}

import { differenceFormattedAsDurationLabel } from '../utils/date';

angular.module('app.filters').filter('dateDuration', ($filter) => {
  'ngInject';
  return (start, end, showSeconds, defaultIfEndNull) => {
    if (defaultIfEndNull && !end) {
      return defaultIfEndNull;
    }
    return differenceFormattedAsDurationLabel(start, end, showSeconds);
  };
});



// WEBPACK FOOTER //
// ./app/filters/date-duration.js